import { render, staticRenderFns } from "./MoleculeVisitorCard.vue?vue&type=template&id=bb9da8a2&scoped=true&"
import script from "./MoleculeVisitorCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeVisitorCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeVisitorCard.vue?vue&type=style&index=0&id=bb9da8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9da8a2",
  null
  
)

export default component.exports